/**
 * Copy for the **order** details drawer.
 *
 * Its own file rather than more keys under `orderDetails`: that namespace was the pre-split
 * drawer's, shared with the claim side, and the whole point of the split is that the two entities stop
 * sharing. The claim drawer's twin is `claims/claim-drawer.ts`. Strings that read the same in both
 * are deliberately written out in each rather than interpolated with a `{type}` — a sentence built
 * from a noun the caller passes in is how the shared drawer got confusing in the first place.
 */
export default {
  summary: {
    title: 'Summary',
    orderItems: 'Order items',
    inventoryTotal: 'Inventory total',
    deliveredTotal: 'Delivered total',
    orderTotal: 'Order Total',
    vatTotal: 'VAT Total',
    pendingVariationsTotal: 'Pending variations total',
    totalInclVat: 'Total Incl VAT',
    vatNote: 'VAT registered vendors will have their VAT % added to their total price',
  },

  inventory: {
    title: 'Order items',
    headers: {
      itemName: 'Item name',
      specification: 'Spec',
      boq: 'BOQ section',
      previous: 'Previous',
      qty: 'Qty',
      rate: 'Rate',
      total: 'Total',
      delivered: 'Delivered',
      actions: 'Actions',
    },
    headerTooltips: {
      previous: 'Quantity already taken against this BOQ line before this order.',
      qty: 'Quantity on this order.',
    },
    variationCause: {
      // The banner is this label wrapped around whichever reasons apply, so a variation moving both
      // figures says so in one strip rather than naming only the first. Mirrors the create-flow
      // inventory step, which words its own causes the same way.
      label: 'Variation · {reasons}',
      reasonSeparator: ', ',
      newLineItem: 'new line item',
      quantityUp: 'quantity increased',
      quantityDown: 'quantity decreased',
      rateUp: 'rate increased',
      rateDown: 'rate decreased',
      // A variation whose figures both land on the line's own has nothing to name, but the row is
      // still marked, so the strip falls back to saying that much.
      valueChanged: 'Variation · value changed',
    },
    itemRemoved: 'This item has been removed from the order',
  },
};
